<div class="row mb-3">
    <div class="col-md-10">
        <h3>{{title}}</h3>
    </div>

    <span class="col-md-2  float-right">
        <button class="btn btn-default" [routerLink]="'/admin/manage-message-guide'">View Message Guide</button>
    </span>
</div>
<div class="add-error-guides">

    <div class="row">
        <div class="col-md-12 mt-2">
            <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                    {{ alert.msg }}
                </div>
            </div>
        </div>
    </div>

    <form [formGroup]="errorGuideForm" (ngSubmit)="errorGuideForm.valid && onSave(errorGuideForm.value)" novalidate>
        <div class="row">
            <div class="form-group mt-3 col-md-12">
                <div class="row">
                    <div class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Support Code :</mat-label>
                            <input matInput placeholder="Code" formControlName="code" required>
                            <mat-error *ngIf="hasError('code', 'required')">Support Code is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Feature :</mat-label>
                            <input matInput placeholder="Feature" formControlName="feature" required>
                            <mat-error *ngIf="hasError('feature', 'required')">Feature is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <p>
                            <mat-label>Platform</mat-label>
                            <mat-button-toggle-group class="toggle-group ml-4" required formControlName="platform" name="Platform">
                                <mat-button-toggle *ngFor="let item of errorGuideOptions" [value]="item.value">{{item.name}}</mat-button-toggle>
                                <!-- <mat-button-toggle value="Dealer Portal">Dealer Portal</mat-button-toggle> -->
                            </mat-button-toggle-group>
                            <mat-error *ngIf="issubmit && hasError('platform', 'required')">Platform is required</mat-error>
                        </p>
                    </div>

                </div>
                <!-- <div > -->
                <div class="row">
                    <div formGroupName="message" class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Solution :</mat-label>
                            <textarea matInput placeholder="Solution" formControlName="solution" rows="3" required></textarea>
                            <mat-error *ngIf="hasError('solution', 'required','message')">Solution is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div formGroupName="message" class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Effect :</mat-label>
                            <textarea matInput placeholder="Effect" formControlName="effect" rows="3" required></textarea>
                            <mat-error *ngIf="hasError('effect', 'required','message')">Effect is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div formGroupName="message" class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Cause :</mat-label>
                            <textarea matInput placeholder="Cause" formControlName="cause" rows="3" required></textarea>
                            <mat-error *ngIf="hasError('cause', 'required','message')">Cause is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div formGroupName="message" class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Content TMNA :</mat-label>
                            <textarea matInput placeholder="Content TMNA" formControlName="contentTMNA" rows="3" required></textarea>
                            <mat-error *ngIf="hasError('contentTMNA', 'required','message')">Content TMNA is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div formGroupName="message" class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Description :</mat-label>
                            <textarea matInput placeholder="Description" formControlName="description" required rows="3"></textarea>
                            <mat-error *ngIf="hasError('description', 'required','message')">Description is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div formGroupName="message" class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Short Description :</mat-label>
                            <textarea matInput placeholder="Short Description" formControlName="shortDescription" rows="3" required></textarea>
                            <mat-error *ngIf="hasError('shortDescription', 'required','message')">Short Description is required</mat-error>
                        </mat-form-field>
                    </div>

                </div>
                <div class="row">

                    <div formGroupName="message" class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Diagnostic :</mat-label>
                            <textarea matInput placeholder="Diagnostic" formControlName="diagnostic" rows="3"></textarea>
                        </mat-form-field>
                    </div>

                    <div formGroupName="message" class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Content TCI :</mat-label>
                            <textarea matInput placeholder="Content TCI" formControlName="contentTCI" rows="3"></textarea>
                        </mat-form-field>
                    </div>

                    <div class="col-4">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>tdPR_SP :</mat-label>
                            <textarea matInput placeholder="tdPR_SP" formControlName="tdPR_SP" rows="3"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-md-12 action-controls">
            <span *ngIf="mode!='view'">
                <button class="btn btn-default" (click)="onSave(errorGuideForm.value)">Save</button>
            </span>
            <span *ngIf="mode=='view'">
                <button class="btn btn-default" (click)="onEdit()">Edit</button>
            </span>
            <span *ngIf="mode!='view'" class="ml-2">
                <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
            </span>
        </div>
    </div>
</div>